module.exports = "/static/img/python.svg?6493e533f780b861b21a9cae971a539d";